// extracted by mini-css-extract-plugin
export default {"base":"logo-text-module--base--LpQoh","icon":"logo-text-module--icon--lr2uu","title":"logo-text-module--title--MQiYZ","subtitle":"logo-text-module--subtitle--TGOpQ"};